module.exports = __webpack_public_path__ + "img/map-pin.8da2ae30.svg";